import { LinearProgress, Typography } from '@material-ui/core';
import { useTranslation } from 'next-i18next';
import { formatDate } from 'utils/FormatDate';
import CountdownTimer from '../CountdownTimer';

import styles from './styles.module.css';

const DealSection = ({
  dealEndDay,
  dealReady,
  dealStartTime,
  maxQuantity,
  totalSold = 0,
  total = 0,
}) => {
  const { t: translateCommon } = useTranslation('common');

  const startDate = formatDate(dealStartTime);
  const totalSoldPercent = (totalSold / total) * 100;
  return (
    <div className={styles.deal_section}>
      <div className={styles.process_wrapper}>
        <LinearProgress
          classes={{
            root: styles.root_process,
            barColorPrimary: styles.bar_background,
            colorPrimary: styles.blur_background,
          }}
          variant="determinate"
          value={totalSoldPercent}
        />
        <Typography className={styles.process_content}>
          {dealReady && maxQuantity === totalSold && translateCommon('deal.sold_out')}
          {dealReady &&
            maxQuantity > totalSold &&
            totalSoldPercent < 75 &&
            `${translateCommon('deal.sold')} ${totalSold}`}
          {dealReady &&
            maxQuantity > totalSold &&
            totalSoldPercent >= 75 &&
            translateCommon('deal.out_of_stock_soon')}
          {!dealReady && translateCommon('deal.on_sale_soon')}
        </Typography>
      </div>
      {dealReady ? (
        <CountdownTimer
          translateCommon={translateCommon}
          className={styles.count_down}
          dealEndDay={dealEndDay}
        />
      ) : (
        <div className={styles.startDate}>{startDate}</div>
      )}
    </div>
  );
};

export default DealSection;
